import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators';

import {
  ParsedEvents,
  eventsService,
  ParsedCompetence,
  professionsService,
  competencesService,
  compModulesService,
  MapedProfessionsType,
} from '@/services';
import { Providers, State } from './types';
import {
  INIT,
  FETCH_ITEM,
  SET_PROGRAMS,
  FETCH_PROGRAMS,
  SET_COMPETENCE,
  SET_PROFESSIONS,
  SET_COMP_MODULES,
  FETCH_PROFESSIONS,
  SET_NOTHING_FOUND,
  FETCH_COMP_MODULES,
} from './consts';

const storeModule = ({ $api }: Providers) => {
  @Module({
    namespaced: true,
    stateFactory: true,
  })
  class CompetenceStore extends VuexModule<State, any> {
    programs: ParsedEvents = [];
    nothingFound: boolean = false;
    competenceModules: Array<string> = [];
    professions: MapedProfessionsType = [];
    competence: ParsedCompetence | null = null;

    @Mutation
    [SET_PROFESSIONS](data: MapedProfessionsType) {
      this.professions = data;
    }

    @Mutation
    [SET_PROGRAMS](data: ParsedEvents) {
      this.programs = data;
    }

    @Mutation
    [SET_COMPETENCE](data: ParsedCompetence) {
      this.competence = data;
    }

    @Mutation
    [SET_NOTHING_FOUND](payload: boolean) {
      this.nothingFound = payload;
    }

    @Mutation
    [SET_COMP_MODULES](payload: Array<string>) {
      this.competenceModules = payload;
    }

    @Action
    async [INIT](id: string) {
      const { commit, dispatch } = this.context;

      if (!id) return;

      try {
        await Promise.all([
          dispatch(FETCH_ITEM, id),
          dispatch(FETCH_PROGRAMS, id),
          dispatch(FETCH_PROFESSIONS, id),
          dispatch(FETCH_COMP_MODULES, id),
        ]);
      } catch (err) {
        const error: any = err;
        if (error.response && error.response.status === 404) {
          commit(SET_NOTHING_FOUND, true);
        }
      }
    }

    @Action
    async [FETCH_ITEM](id: string) {
      const { commit } = this.context;

      try {
        const { data } = await competencesService($api).getCompetence(id);
        commit(SET_COMPETENCE, data);
      } catch (err) {
        commit(SET_COMPETENCE, []);
      }
    }

    @Action
    async [FETCH_PROFESSIONS](id: string) {
      const { commit } = this.context;

      try {
        const { data } = await professionsService($api).getProfessions({
          competence_id: id,
        });
        commit(SET_PROFESSIONS, data);
      } catch (err) {
        commit(SET_PROFESSIONS, []);
      }
    }

    @Action
    async [FETCH_PROGRAMS](id: string) {
      const { commit } = this.context;

      try {
        const { data } = await eventsService($api).getEvents({
          competence: id,
        });
        commit(SET_PROGRAMS, data);
      } catch (err) {
        commit(SET_PROGRAMS, []);
      }
    }

    @Action
    async [FETCH_COMP_MODULES](id: string) {
      const { commit } = this.context;

      try {
        const { data } = await compModulesService($api).getModules({
          competence_id: id,
        });
        commit(SET_COMP_MODULES, data);
      } catch (err) {
        commit(SET_COMP_MODULES, []);
      }
    }
  }

  return CompetenceStore;
};

export default storeModule;



// WEBPACK FOOTER //
// ./src/pages/competences/card/store.ts